import {
  DEFAULT_GRID_COLUMNS,
  DEFAULT_GRID_ROWS,
} from '../components/PageConfigProvider/constants';
import type { TabContent } from '../components/PageConfigProvider/page-reducer';
import {
  type Page,
  PageType,
  RevelioPageId,
} from '../components/PageConfigProvider/types';
import { FilterId } from '../filters/types/filters';

const companyTransitionsItems: TabContent['items'] = [
  {
    position: { x: 0, width: 32, y: 0, height: 36 },
    id: 'company-transitions-v2-sankey',
    title: 'Transition',
    info: {
      text: 'The most common sources of incoming workers and destinations of outgoing workers over the last two years by default.',
    },
    plot: {
      defaultMetricOptions: ['transitions_inflows_and_outflows'],
      chartType: 'sankey',
    },
  },
  {
    position: { x: 32, width: 16, y: 0, height: 18 },
    id: 'company-transitions-v2-role',
    title: 'Role',
    info: {
      text: 'Worker inflows and outflows by occupation, as well as the net change, over the last two years by default. More information on the job representation and taxonomy can be found <a>.',
      hyperlinks: [
        {
          text: 'here',
          href: 'https://www.data-dictionary.reveliolabs.com/methodology.html#jobs-taxonomy',
        },
      ],
    },
    plot: {
      secondaryDimension: 'role',
      defaultMetricOptions: ['transitions_inflows_and_outflows'],
      chartType: 'diverging-bar-combo',
      showDataLabels: true,
      divergingBarCombo: {
        comparisonLabel: '',
        differenceLabel: '',
        leftHeaderLabel: '',
        rightHeaderLabel: '',
        sort: { by: 'sum' },
      },
      comparisonTransformation: {
        baseline: 'second',
      },
    },
  },
  {
    position: { x: 32, width: 16, y: 18, height: 18 },
    id: 'company-transitions-v2-geography',
    title: 'Geography',
    info: {
      text: 'Worker inflows and outflows by geography, as well as the net change, over the last two years by default.',
    },
    plot: {
      secondaryDimension: 'geography',
      defaultMetricOptions: ['transitions_inflows_and_outflows'],
      chartType: 'diverging-bar-combo',
      showDataLabels: true,
      divergingBarCombo: {
        comparisonLabel: '',
        differenceLabel: '',
        leftHeaderLabel: '',
        rightHeaderLabel: '',
        sort: { by: 'sum' },
      },
      comparisonTransformation: {
        baseline: 'second',
      },
    },
  },
];

const companyTransitionsTab: TabContent = {
  id: 'company-transitions-v2',
  items: companyTransitionsItems,
  primaryFilter: {
    id: FilterId.COMPANY,
    selectionLimit: 6,
    selectionDefault: 1,
    tagColors: true,
  },
  grid: { rows: DEFAULT_GRID_ROWS, columns: DEFAULT_GRID_COLUMNS },
  secondaryFilters: [
    FilterId.CONTINGENT_WORKERS,
    FilterId.EDUCATION,
    FilterId.ETHNICITY,
    FilterId.GENDER,
    FilterId.GEOGRAPHY,
    FilterId.ROLE,
    FilterId.SENIORITY,
    FilterId.SKILL,
    FilterId.CUSTOM_SKILL,
    FilterId.DATE_RANGE,
    FilterId.KEYWORDS,
    FilterId.TITLE,
  ].map((id) => ({ id })),
  dateRangeDefault: 'last-2-years',
};

export const companyTransitionsV2: Page = {
  type: PageType.REVELIO_PUBLIC,
  id: RevelioPageId.COMPANY_TRANSITIONS_V2,
  revelioPageId: RevelioPageId.COMPANY_TRANSITIONS_V2,
  name: 'Transitions',
  owner: { id: 'revelio-labs', username: 'revelio-labs' },
  tabs: [
    {
      id: 'company-transitions-v2',
      label: 'Transitions',
      isActive: true,
      tabContent: companyTransitionsTab,
    },
  ],
};
